import React, { useMemo } from "react";
import PT from "prop-types";
import { InputWrap, PinIcon } from "./styled";
import { useColorScheme } from "@/hooks/useColorScheme";
import { AsyncSelect } from "@/components/Select";
import { CitiesAPI } from "@/api/cities";
import BrowserOnly from "@/components/BrowserOnly";
import { useHighlightedCitiesQuery } from "@/hooks/queries/useHighlightedCitiesQuery";

const PlacesAutocomplete = (props) => {
  const colorScheme = useColorScheme();
  const defaultOptionsQuery = useHighlightedCitiesQuery();
  const defaultOptions = useMemo(() => {
    if (!defaultOptionsQuery.data) {
      return [];
    }
    return defaultOptionsQuery.data.map((city) => ({
      label: city.name,
      value: city.slug,
    }));
  }, [defaultOptionsQuery.data]);
  return (
    <InputWrap>
      <BrowserOnly>
        <AsyncSelect
          value={props.location}
          onFocus={props.onFocus}
          inputId="master-search-city-input"
          classNamePrefix="masters-search-autocomplete"
          onChange={props.onSelect}
          noOptionsMessage={() => props.t("common:empty")}
          cacheOptions
          placeholder={props.t("common:search_form.city")}
          loadingMessage={() => props.t("common:loading")}
          loadOptions={async (input) => {
            const { items } = await CitiesAPI.autocomplete({ query: input });
            return items.map((i) => ({ value: i.slug, label: i.name }));
          }}
          defaultOptions={defaultOptions}
        />
      </BrowserOnly>
      <PinIcon color={colorScheme === "dark" ? "#fff" : "#d1179e"} />
    </InputWrap>
  );
};
PlacesAutocomplete.propTypes = {
  onSelect: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default PlacesAutocomplete;
